import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-widget-panel',
  templateUrl: './widget-panel.component.html',
  styleUrls: ['./widget-panel.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WidgetPanelComponent implements OnInit {
  constructor() {}

  @Input() widgetStyle: { [key: string]: string } = {};

  ngOnInit(): void {}
}
